<template>
	<div class="gb-header-schedule-filtering">
		<v-alert
			v-bind:value="value"
			color="info"
			icon="info"
			outline
			dismissible
			@input="onInput"
		>
			フィルタリング中
		</v-alert>
	</div>
</template>
<script>
export default {
	name: 'GBHeaderScheduleFiltering',
	props: [
		"value",
	],
	methods: {
		onInput (value) {
			if (!value) {
				this.$store.dispatch('updateScheduleFilter', {
					projects: [],
					members: [],
					begin: null,
					end: null,
					classes: [],
					color_project: [],
					color_member: [],
					additional_info_data: [],
					alert: false,
					status: this.$store.getters.scheduleFilter.status,
				});
			}
		},
	},
}
</script>
<style>
	.gb-header-schedule-filtering {
		background-color: #ffffff;
	}
</style>
